import { Controller } from 'react-hook-form';

import AlxSelect, { IAlxSelect } from '../../alx-components/select';
import { UseControllerProps } from './forms-types';

interface ISelectControllerProps {
  selectProps: IAlxSelect;
  controllerProps: UseControllerProps;
}

const ControlledSelect: React.FC<ISelectControllerProps> = ({ selectProps, controllerProps }) => {
  return (
    <Controller
      {...controllerProps}
      render={({ field }) => <AlxSelect {...field} {...selectProps} />}
      rules={{
        ...controllerProps.rules,
      }}
    />
  );
};

export default ControlledSelect;
